// focus-manager.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FocusManagerService {
    private readonly activeComponentId$ = new BehaviorSubject<string | null>(null);

    setActive(id: string): void {
        this.activeComponentId$.next(id);
    }

    clearActive(): void {
        this.activeComponentId$.next(null);
    }

    get active$(): Observable<string | null> {
        return this.activeComponentId$.asObservable();
    }

    get currentActive(): string | null {
        return this.activeComponentId$.getValue();
    }
}
